 /* eslint-disable max-lines */
 // tslint:disable-next-line:max-line-length
import { TRACKING_TYPES } from '@vfde-fe/ngx-lib/core';
/** config */
export const config = {
    generalError: {
        name: 'allgemeiner_fehler',
        route: '/allgemeiner_fehler',
    },
    unauthorized: {
        name: 'nicht_erlaubt',
        route: '/nicht_erlaubt',
        navigation: {
            topLink: true,
            mobileBtn: false,
            navigationLink: '/meinvodafone/services/',
            mobileBtnLabelKey: 'common.buttons.cancel.std-headline',
        },
    },
    login: {
        name: 'login',
        route: '/login',
        titleKey: 'loginModule.title.std-headline',
        tracking: {
            trackingType: TRACKING_TYPES.PAGE_TRACKING,
            trackingTags: {
                siteArea: 'after sales',
                isCustomSiteStructure: true,
                hasOApplication: false,
                siteStructure: [
                    'privatkunden',
                    'after sales portal',
                    'login',
                ],
            },
        },
    },
    revocation: {
        name: 'revocation',
        route: '/revocation',
        revocationSimHardware: {
            name: 'sim-hardware',
            route: '/revocation/sim-hardware',
        },
        hardwareAndSimRevocationOptions: {
            name: 'sim-hardware-options',
            route: '/revocation/sim-hardware-options',
            flowManagementID: 'revocation-options',
            titleKey: 'revocationModule.simHardware.options.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle',
                        'revoke options',
                    ],
                },
            },
        },
        hardwareAndSimRevocationStepOne: {
            name: 'sim-hardware-step-one',
            route: '/revocation/sim-hardware-step-one',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            flowManagementID: 'revocation-step-one',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device',
                        'select device',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device',
                    stepName: 'select device',
                    status: ['start'],
                },
            },
        },
        hardwareAndSimRevocationStepTwo: {
            name: 'sim-hardware-step-two',
            route: '/revocation/sim-hardware-step-two',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            flowManagementID: 'revocation-step-two',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device',
                        'device details',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device',
                    stepName: 'device details',
                    status: [],
                },
            },
        },
        hardwareAndSimRevocationStepThree: {
            name: 'sim-hardware-step-three',
            route: '/revocation/sim-hardware-step-three',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        hardwareAndSimRevocationStepFour: {
            name: 'sim-hardware-step-four',
            route: '/revocation/sim-hardware-step-four',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        hardwareAndEsimRevocationStepFour: {
            name: 'esim-hardware-step-four',
            route: '/revocation/esim-hardware-step-four',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device',
                    stepName: 'summary',
                    status: [],
                },
            },
        },

        hardwareAndEsimRevocationOptions: {
            name: 'esim-hardware-options',
            route: '/revocation/esim-hardware-options',
            flowManagementID: 'revocation-options',
            titleKey: 'revocationModule.simHardware.options.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle esim',
                        'revoke options',
                    ],
                },
            },
        },
        hardwareAndEsimRevocationStepOne: {
            name: 'esim-hardware-step-one',
            route: '/revocation/esim-hardware-step-one',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            flowManagementID: 'revocation-step-one',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/revocation/esim-hardware-options',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device esim',
                        'select device',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device esim',
                    stepName: 'select device',
                    status: ['start'],
                },
            },
        },
        hardwareAndEsimRevocationStepTwo: {
            name: 'esim-hardware-step-two',
            route: '/revocation/esim-hardware-step-two',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            flowManagementID: 'revocation-step-two',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device esim',
                        'device details',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device esim',
                    stepName: 'device details',
                    status: [],
                },
            },
        },
        hardwareAndEsimRevocationStepThree: {
            name: 'esim-hardware-step-three',
            route: '/revocation/esim-hardware-step-three',
            titleKey: 'revocationModule.simHardware.hardwareSelection.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle other device esim',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle other device esim',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        simRevocationOptions: {
            name: 'sim-options',
            route: '/revocation/sim-options',
            flowManagementID: 'sim-revocation-options',
            titleKey: 'revocationModule.simOnly.options.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'sim only',
                        'revoke options',
                    ],
                },
            },
        },
        dslRevocationOptions: {
            name: 'dsl-options',
            route: '/revocation/dsl-options',
            flowManagementID: 'dsl-revocation-options',
            titleKey: 'revocationModule.simOnly.options.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'dsl return',
                        'summary',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'dsl return',
                    stepName: 'summary',
                    status: ['start'],
                },
            },
        },
        accessoriesSelection: {
            name: 'accessories-selection',
            route: '/revocation/accessories-selection',
            titleKey: 'revocationModule.accessories.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory return',
                        'article selection',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory return',
                    stepName: 'article selection',
                    status: ['start'],
                },
            },
        },
        revocationSelection: {
            name: 'revocation-selection',
            route: '/revocation/revocation-selection',
            titleKey: 'revocationModule.revocationSelection.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                logout: '/landing-page?logout=true',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory return',
                        'article selection',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory return',
                    stepName: 'article selection',
                    status: ['start'],
                },
            },
        },
        oteloSimhardware: {
            name: 'otelo-sim-hardware',
            route: '/revocation/otelo-sim-hardware',
            // flowManagementID: 'revocation-options',
            titleKey: 'revocationModule.otelo.title.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: 'transaction',
                trackingTags: {
                    siteStructure: ['privatkunden', 'after sales portal', 'otelo bundle return', 'summary'],
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteArea: 'after sales',
                    module: 'otelo bundle return',
                    type: 'after sales portal',
                    step: '1',
                    stepName: 'summary',
                    status: ['start'],
                },
            },
        },
        gigaCubeRevocationOptions: {
            name: 'gigacube-options',
            route: '/revocation/gigacube-options',
            flowManagementID: 'gigacube-revocation-options',
            titleKey: 'revocationModule.gigaCube.options.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube return',
                        'revoke options',
                    ],
                },
            },
        },
        esimRevocationOptions: {
            name: 'esim-options',
            route: '/revocation/esim-options',
            flowManagementID: 'sim-revocation-options',
            titleKey: 'revocationModule.simOnly.options.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'esim only',
                        'revoke options',
                    ],
                },
            },
        },
    },
    serviceAgent: {
        name: 'service-agent',
        route: '/service-agent',
        consultantChooser: {
            name: 'consultant-chooser',
            route: '/service-agent/consultant-chooser',
            titleKey: {
                simHardware: 'serviceAgentModule.consultantChooser.default.std-headline',
                defectReturn: 'serviceAgentModule.consultantChooser.defect-return.std-headline',
                secondDeliveryDifferent: 'serviceAgentModule.consultantChooser.2nd-delivery-different.std-headline',
                DEFAULT: 'simHardware',
            },
            flowManagementID: 'consultant-chooser',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'service agent',
                        '{{devicesStatus}}',
                    ],
                },
            },
        },
        chat: {
            name: 'chat',
            route: '/service-agent/chat',
            titleKey: 'serviceAgentModule.chat.std-headline',
            flowManagementID: 'chat',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'serviceAgentModule.chat.backButton.std-headline',
                navigationLink: '/overview',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'service agent',
                        'chat page',
                    ],
                },
            },
        },
        UMCableChat: {
            name: 'um-cable-chat',
            route: '/service-agent/um-cable-chat',
            titleKey: 'serviceAgentModule.chat.umCableTitleKey.std-headline',
            flowManagementID: 'chat',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'serviceAgentModule.chat.umCablebackButton.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'service agent',
                        'chat page',
                    ],
                },
            },
        },
    },

    openQuestions: {
        name: 'open-questions',
        route: '/open-questions',
        OpenQuestionsPage: {
            name: 'open-questions-page',
            route: '/open-questions/open-questions-page',
            titleKey: 'openQuestionsModule.pageTitle.std-headline',
            flowManagementID: 'open-questions-page',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'open questions',
                    ],
                },
            },
        },
    },
    salesAgent: {
        name: 'sales-agent',
        route: '/sales-agent',
        SalesAgentPage: {
            name: 'sales-agent-page',
            route: '/sales-agent/sales-agent-page',
            titleKey: 'salesAgentModule.pageTitle.std-headline',
            notifyBeforeUnload: true,
            flowManagementID: 'sales-agent',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                navigationLink: '/overview',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'sales agent',
                    ],
                },
            },
        },
    },
    winback: {
        name: 'winback',
        route: '/winback',
        WinbackPage: {
            name: 'winback-page',
            route: '/winback/winback-page',
            titleKey: 'winbackModule.pageTitle.default.std-headline',
            flowManagementID: 'winback-page',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/overview',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    platformType: 'responsive',
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        '{{moduleName}}',
                        '{{stepName}}',
                    ],
                    step: 1,
                    type: 'after sales portal',
                    module: '{{moduleName}}',
                    stepName: '{{stepName}}',
                    status: ['start'],
                },
            },
        },
        gigaCubeWinback: {
            name: 'gigacube-winback',
            route: '/winback/gigacube-winback',
            titleKey: 'winbackModule.pageTitle.gigaCube.std-headline',
            flowManagementID: 'gigacube-winback',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/overview',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    platformType: 'responsive',
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube return',
                        'winback',
                    ],
                    step: 1,
                    type: 'after sales portal',
                    module: 'gigacube return',
                    stepName: 'winback',
                    status: ['start'],
                },
            },
        },
    },
    confirmation: {
        name: 'confirmation',
        route: '/confirmation',
        showOldView: false,
        simHardwareRevocationConfirmation: {
            name: 'sim-hardware-revocation',
            route: '/confirmation/sim-hardware-revocation',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        '{{moduleName}}',
                        'confirmation',
                    ],
                    step: '{{confirmationStepNumber}}',
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: '{{moduleName}}',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                    oOrder: {
                        aProducts: {
                            sku: '{{articleNumber}}',
                            name: '{{deviceName}}',
                            priceOnce: '{{priceOnce}}',
                            type: 'device',
                        },
                        aPropositions: {
                            id: 1,
                            name: '{{deviceName}}',
                            targetAudience: 'consumer',
                            retention: '{{retention}}',
                            productType: 'debit',
                            productLine: 'voice',
                            productCategory: 'device',
                            units: 1,
                            shippingMedthod: 'home',
                            shippingPrice: '0.0',
                        },
                    },
                },
            },
        },
        simHardwareSecondDeliveryConfirmation: {
            name: 'sim-hardware-second-delivery',
            route: '/confirmation/sim-hardware-second-delivery',
            titleKey: 'confirmationModule.simHardwareSecondDeliveryConfirmation.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'second delivery request delivery',
                        'confirmation',
                    ],
                    step: 2,
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'second delivery request delivery',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },

        },
        simOnlyRevocationConfirmation: {
            name: 'sim-only',
            route: '/confirmation/sim-only',
            titleKey: 'confirmationModule.simOnlyRevocationConfirmation.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'sim only not happy',
                        'confirmation',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'sim only not happy',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        dslConfirmation: {
            name: 'dsl',
            route: '/confirmation/dsl',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'dsl return',
                        'confirmation',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'dsl return',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        accessoriesRevocationConfirmation: {
            name: 'accessories-revoked',
            route: '/confirmation/accessories-revoked',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory return',
                        'confirmation',
                    ],
                    step: '{{step}}',
                    outcome: '{{outcome}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory return',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        accessoriesDefectConfirmation: {
            name: 'accessories-defected',
            route: '/confirmation/accessories-defected',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory defect',
                        'confirmation',
                    ],
                    step: 3,
                    outcome: '{{outcome}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory defect',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        enterpriseDefectConfirmation: {
            name: 'enterprise-defected',
            route: '/confirmation/enterprise-defected',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.Elephant.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'enterprise defect',
                        'confirmation',
                    ],
                    step: 3,
                    outcome: '{{outcome}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'enterprise defect',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        babyElephantDefectConfirmation: {
            name: 'enterprise-b-confirmation',
            route: '/confirmation/enterprise-b-confirmation',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'any customer defect',
                        'confirmation',
                    ],
                    step: 3,
                    outcome: '{{outcome}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'any customer defect',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        oteloConfirmation: {
            name: 'otelo-summary',
            route: '/confirmation/otelo-summary',
            titleKey: 'confirmationModule.oteloConfirmation.title.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: 'transaction',
                trackingTags: {
                    siteStructure: ['privatkunden',
                        'after sales portal',
                        'otelo bundle return',
                        'confirmation'],
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteArea: 'after sales',
                    module: 'otelo bundle return',
                    type: 'after sales portal',
                    step: '2',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        simHardwareDefectReturnConfirmation: {
            name: 'sim-hardware-defect',
            route: '/confirmation/sim-hardware-defect',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect',
                        'confirmation',
                    ],
                    step: '4',
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'bundle defect',
                    stepName: 'confirmation',
                    outcome: '{{outcome}}',
                    status: ['end', 'success'],
                },
            },
        },
        eSimHardwareDefectReturnConfirmation: {
            name: 'esim-hardware-defect',
            route: '/confirmation/esim-hardware-defect',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect esim',
                        'confirmation',
                    ],
                    step: '4',
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'bundle defect esim',
                    stepName: 'confirmation',
                    outcome: '{{outcome}}',
                    status: ['end', 'success'],
                },
            },
        },
        oteloSimHardwareDefectReturnConfirmation: {
            name: 'otelo-sim-hardware-defect',
            route: '/confirmation/otelo-sim-hardware-defect',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'otelo bundle defect',
                        'confirmation',
                    ],
                    step: '4',
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'otelo bundle defect',
                    stepName: 'confirmation',
                    outcome: '{{outcome}}',
                    status: ['end', 'success'],
                },
            },
        },
        dslDefectConfirmation: {
            name: 'dsl-defect-confirmation',
            route: '/confirmation/dsl-defect-confirmation',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'dsl defect',
                        'confirmation',
                    ],
                    step: 3,
                    outcome: '{{outcome}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'dsl defect',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        gigaCubeDefectReturnConfirmation: {
            name: 'gigacube-defect',
            route: '/confirmation/gigacube-defect',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube defect',
                        'confirmation',
                    ],
                    step: '4',
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'gigacube defect',
                    stepName: 'confirmation',
                    outcome: '{{outcome}}',
                    status: ['end', 'success'],
                },
            },
        },
        gigaCubeRevocationConfirmation: {
            name: 'gigacube-revocation',
            route: '/confirmation/gigacube-revocation',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube return',
                        'confirmation',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'gigacube return',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        eSimOnlyRevocationConfirmation: {
            name: 'esim-only',
            route: '/confirmation/esim-only',
            titleKey: 'confirmationModule.esimOnlyRevocationConfirmation.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'esim only not happy',
                        'confirmation',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'esim only not happy',
                    stepName: 'confirmation',
                    status: ['end', 'success'],
                },
            },
        },
        eSimHardwareRevocationConfirmation: {
            name: 'esim-hardware-revocation',
            route: '/confirmation/esim-hardware-revocation',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.default.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/overview',
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                headerKey: 'common.buttons.backToHomePage.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        '{{moduleName}}',
                        'confirmation',
                    ],
                    step: '{{confirmationStepNumber}}',
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: '{{moduleName}}',
                    stepName: 'confirmation',
                    outcome: '{{outcome}}',
                    status: ['end', 'success'],
                    oOrder: {
                        aProducts: {
                            sku: '{{articleNumber}}',
                            name: '{{deviceName}}',
                            priceOnce: '{{priceOnce}}',
                            type: 'device',
                        },
                        aPropositions: {
                            id: 1,
                            name: '{{deviceName}}',
                            targetAudience: 'consumer',
                            retention: '{{retention}}',
                            productType: 'debit',
                            productLine: 'voice',
                            productCategory: 'device',
                            units: 1,
                            shippingMedthod: 'home',
                            shippingPrice: '0.0',
                        },
                    },
                },
            },
        },
        unityMediaRevocationConfirmation: {
            name: 'kabel',
            route: '/confirmation/kabel',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.UMCable.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/landing-page',
                mobileBtnLabelKey: 'confirmationModule.sharedRevocationConfirmation.UMCable.titleKey.back-btn.std-headline',
                headerKey: 'confirmationModule.sharedRevocationConfirmation.UMCable.titleKey.back-btn.std-headline',
            },
        },
        dsl: {
            name: 'dsl-extension',
            route: '/confirmation/dsl-extension',
            titleKey: 'confirmationModule.sharedRevocationConfirmation.UMCable.titleKey.std-headline',
            confirmationPage: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                navigationLink: '/landing-page',
                mobileBtnLabelKey: 'confirmationModule.sharedRevocationConfirmation.UMCable.titleKey.back-btn.std-headline',
                headerKey: 'confirmationModule.sharedRevocationConfirmation.UMCable.titleKey.back-btn.std-headline',
            },
        },
    },
    review: {
        name: 'review',
        route: '/review',
        revockSimHardware: {
            name: 'revock/simHardware',
            route: '/review/revock/simHardware',
            titleKey: 'reviewModule.simHardwareWinback.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle cancel tariff {{forEsim}}',
                        'summary',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle cancel tariff {{forEsim}}',
                    stepName: 'summary',
                    status: '{{status}}',
                },
            },
        },
        defectSimHardware: {
            name: 'defect/simHardware',
            route: '/review/defect/simHardware',
            titleKey: 'reviewModule.simHardwareDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle defect',
                    stepName: 'summary',
                    status: [],
                },
            },

        },
        defectEsimHardware: {
            name: 'defect/esimHardware',
            route: '/review/defect/esimHardware',
            titleKey: 'reviewModule.simHardwareDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect esim',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle defect esim',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        oteloDefectSimHardware: {
            name: 'defect/otelo-simHardware',
            route: '/review/defect/otelo-simHardware',
            titleKey: 'reviewModule.simHardwareDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'otelo bundle defect',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'otelo bundle defect',
                    stepName: 'summary',
                    status: [],
                },
            },

        },
        reviewRevokedAccessories: {
            name: 'accessories-revoked',
            route: '/review/accessories-revoked',
            titleKey: 'revocationModule.accessories.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory return',
                        'summary',
                    ],
                    step: '{{step}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory return',
                    stepName: 'summary',
                    status: '{{status}}',
                },
            },
        },
        reviewDefectAccessoreis: {
            name: 'accessories-defect',
            route: '/review/accessories-defect',
            titleKey: 'defectReturnModule.accessories.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory defect',
                        'summary',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory defect',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        defectDsl: {
            name: 'dsl-defect-review',
            route: '/review/dsl-defect-review',
            titleKey: 'defectReturnModule.dsl.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'dsl defect',
                        'summary',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'dsl defect',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        defectGigaCube: {
            name: 'defect/gigacube',
            route: '/review/defect/gigacube',
            titleKey: 'reviewModule.simHardwareDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube defect',
                        'summary',
                    ],
                    step: 3,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'gigacube defect',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        revokeGigaCube: {
            name: 'revoke/gigaCube',
            route: '/review/revoke/gigaCube',
            titleKey: 'reviewModule.gigaCubeRevoke.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube return',
                        'summary',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'gigacube return',
                    stepName: 'summary',
                    status: '{{status}}',
                },
            },
        },
        reviewDefectEnterprise: {
            name: 'enterprise-defect',
            route: '/review/enterprise-defect',
            titleKey: 'defectReturnModule.enterprise.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            } ,
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'enterprise defect',
                        'summary',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'enterprise defect',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        reviewDefectBabyElephant: {
            name: 'enterprise-b-defect',
            route: '/review/enterprise-b-defect',
            titleKey: 'defectReturnModule.enterprise.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'any customer defect',
                        'summary',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'any customer defect',
                    stepName: 'summary',
                    status: [],
                },
            },
        },
        revocationSelectionReview: {
            name: 'revocation-selection-review',
            route: '/review/revocation-selection-review',
            titleKey: 'revocationModule.revocationSelection.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory return',
                        'summary',
                    ],
                    step: '{{step}}',
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'accessory return',
                    stepName: 'summary',
                    status: '{{status}}',
                },
            },
        },
    },
    secondDelivery: {
        name: 'second-delivery',
        route: '/second-delivery',
        simHardwareSecondDelivery: {
            name: 'sim-hardware',
            route: '/second-delivery/sim-hardware',
            titleKey: 'secondDeliveryModule.simHardware.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'second delivery request delivery',
                        'summary',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'second delivery request delivery',
                    stepName: 'summary',
                    status: ['start'],
                },
            },
        },
        eSimHardwareSecondDelivery: {
            name: 'esim-hardware',
            route: '/second-delivery/esim-hardware',
            titleKey: 'secondDeliveryModule.simHardware.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'esim second delivery request delivery',
                        'summary',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'esim second delivery request delivery',
                    stepName: 'summary',
                    status: ['start'],
                },
            },
        },
    },
    defect: {
        name: 'defect',
        route: '/defect',
        simHardwareReportingDefect: {
            name: 'sim-hardware/reporting-defect',
            route: '/defect/sim-hardware/reporting-defect',
            titleKey: 'defectReturnModule.reportingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect',
                        'select article',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle defect',
                    stepName: 'select article',
                    status: ['start'],
                },
            },
        },
        simHardwareSpecifyingDefect: {
            name: 'sim-hardware/specifying-defect',
            route: '/defect/sim-hardware/specifying-defect',
            titleKey: 'defectReturnModule.specifyingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect',
                        'defect reason',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle defect',
                    stepName: 'defect reason',
                    status: [],
                },
            },
        },
        esimHardwareSpecifyingDefect: {
            name: 'esim-hardware/specifying-defect',
            route: '/defect/esim-hardware/specifying-defect',
            titleKey: 'defectReturnModule.specifyingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect esim',
                        'defect reason',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle defect esim',
                    stepName: 'defect reason',
                    status: [],
                },
            },
        },
        otelSimHardwareSpecifyingDefect: {
            name: 'otelo-sim-hardware/specifying-defect',
            route: '/defect/otelo-sim-hardware/specifying-defect',
            titleKey: 'defectReturnModule.specifyingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'otelo bundle defect',
                        'defect reason',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'otelo bundle defect',
                    stepName: 'defect reason',
                    status: [],
                },
            },
        },
        accessories: {
            name: 'accessories-selection',
            route: '/defect/accessories-selection',
            titleKey: 'defectReturnModule.accessories.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'accessory defect',
                        'article selection',
                    ],
                    step: 1,
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'accessory defect',
                    stepName: 'article selection',
                    status: ['start'],
                },
            },
        },
        dsl: {
            name: 'dsl-report-defect',
            route: '/defect/dsl-report-defect',
            titleKey: 'defectReturnModule.dsl.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'dsl defect',
                        'article selection',
                    ],
                    step: 1,
                    type: 'after sales portal',
                    platformType: 'responsive',
                    module: 'dsl defect',
                    stepName: 'article selection',
                    status: ['start'],
                },
            },
        },
        oteloSimOnly: {
            name: 'otelo-sim-only/reporting-defect',
            route: '/defect/otelo-sim-only/reporting-defect',
            titleKey: 'defectReturnModule.reportingDefect.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'otelo report defect',
                        'defect sim',
                    ],
                },
            },
        },
        oteloSimhardwareDefect: {
            name: 'otelo-sim-hardware',
            route: '/defect/otelo-sim-hardware',
            titleKey: 'defectReturnModule.oteloHardwareReportDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'otelo bundle defect',
                        'select article',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'otelo bundle defect',
                    stepName: 'select article',
                    status: ['start'],
                },
            },
        },
        gigaCubeReportingDefect: {
            name: 'gigacube/reporting-defect',
            route: '/defect/gigacube/reporting-defect',
            titleKey: 'defectReturnModule.reportingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube defect',
                        'select article',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'gigacube defect',
                    stepName: 'select article',
                    status: ['start'],
                },
            },
        },
        gigaCubeSpecifyingDefect: {
            name: 'gigacube/specifying-defect',
            route: '/defect/gigacube/specifying-defect',
            titleKey: 'defectReturnModule.specifyingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'gigacube defect',
                        'defect reason',
                    ],
                    step: 2,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'gigacube defect',
                    stepName: 'defect reason',
                    status: [],
                },
            },
        },
        esimReportingDefectInformation: {
            name: 'esim/reporting-defect-information',
            route: '/defect/esim/reporting-defect-information',
            titleKey: 'defectReturnModule.reportingDefect.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.PAGE_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'informative page',
                    ],
                },
            },
        },
        esimAndHardwareReportingDefect: {
            name: 'esim-and-hardware/reporting-defect',
            route: '/defect/esim-and-hardware/reporting-defect',
            titleKey: 'defectReturnModule.reportingDefect.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'bundle defect esim',
                        'select article',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'bundle defect esim',
                    stepName: 'select article',
                    status: ['start'],
                },
            },
        },
        enterprise: {
            name: 'enterprise-selection',
            route: '/defect/enterprise-selection',
            titleKey: 'defectReturnModule.enterprise.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'enterprise defect',
                        'article selection',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'enterprise defect',
                    stepName: 'article selection',
                    status: ['start'],
                },
            },
        },
        babyElephantSelection: {
            name: 'enterprise-b-selection',
            route: '/defect/enterprise-b-selection',
            titleKey: 'defectReturnModule.enterprise.titleKey.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteArea: 'after sales',
                    isCustomSiteStructure: true,
                    hasOApplication: false,
                    siteStructure: [
                        'privatkunden',
                        'after sales portal',
                        'any customer defect',
                        'article selection',
                    ],
                    step: 1,
                    platformType: 'responsive',
                    type: 'after sales portal',
                    module: 'any customer defect',
                    stepName: 'article selection',
                    status: ['start'],
                },
            },
        },
    },

    overview: {
        name: 'overview',
        route: '/overview',
        tracking: {
            trackingType: TRACKING_TYPES.PAGE_TRACKING,
            trackingTags: {
                siteArea: 'after sales',
                isCustomSiteStructure: true,
                hasOApplication: false,
                siteStructure: [
                    'privatkunden',
                    'after sales portal',
                    'order overview',
                ],
            },
        },
        oteloHardwareOverview: {
            name: 'otelo-sim-hardware',
            route: '/overview/otelo-sim-hardware',
            flowManagementID: 'otelo-hardware-overview',
            notifyBeforeUnload: false,
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        mobileContractWithHardware: {
            name: 'mobile-contract-with-hardware',
            route: '/overview/mobile-contract-with-hardware',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        simOnly: {
            name: 'sim-only',
            route: '/overview/sim-only',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        accessories: {
            name: 'accessories',
            route: '/overview/accessories',
            titleKey: 'overview.accessories.title.std-headline',
            navigation: {
                topLink: false,
                hideBackLink: false,
                mobileBtn: false,
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        hardwareSimSecondDelivery: {
            name: 'hardware-sim-second-delivery',
            route: '/overview/hardware-sim-second-delivery',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        gigacubeSecondDelivery: {
            name: 'gigacube-second-delivery',
            route: '/overview/gigacube-second-delivery',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        simOnlySecondDelivery: {
            name: 'sim-only-second-delivery',
            route: '/overview/sim-only-second-delivery',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        hardwareEsimSecondDelivery: {
            name: 'hardware-esim-second-delivery',
            route: '/overview/hardware-esim-second-delivery',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        dsl: {
            name: 'dsl',
            route: '/overview/dsl',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        gigaCube: {
            name: 'gigacube',
            route: '/overview/gigacube',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        elephantOverview: {
            name: 'enterprise',
            route: '/overview/enterprise',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        babyElephantOverview: {
            name: 'enterprise-b',
            route: '/overview/enterprise-b',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        esimOnly: {
            name: 'esim-only',
            route: '/overview/esim-only',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
        hardwareEsim: {
            name: 'hardware-esim',
            route: '/overview/hardware-esim',
            titleKey: 'overview.common.title.std-headline',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '',
                mobileBtnLabelKey: '',
                headerKey: '',
                logout: '/landing-page?logout=true',
                logoutLabelKey: 'common.buttons.logout.std-headline',
            },
        },
    },
    cancelContract: {
        name: 'kuendigen',
        route: '/kuendigen',
        titleKey: {
            Giraffe: 'CancelContractModule.titleKey.Giraffe.std-headline',
            Camel: 'CancelContractModule.titleKey.Camel.std-headline',
            Deer: 'CancelContractModule.titleKey.Deer.std-headline',
            Fox: 'CancelContractModule.titleKey.Fox.std-headline',
            Buffalo:'CancelContractModule.titleKey.Buffalo.std-headline',
            Cobra:'CancelContractModule.titleKey.Cobra.std-headline',
            Python:'CancelContractModule.titleKey.Python.std-headline',
            Moose: 'CancelContractModule.titleKey.Moose.std-headline',
        },
        notifyBeforeUnload: true,
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
            headerKey: 'common.buttons.backToHomePage.std-headline',
            navigationLink: '/landing-page',

        },
        stepper: [
            {
                name: 'step1',
                tracking: {
                    trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                    trackingTags: {
                        hasOApplication: false,
                        isCustomSiteStructure: true,
                        siteArea: 'after sales',
                        module: '{{persona}}',
                        step: '{{step}}',
                        stepName: 'personal information',
                        status: [],
                        type: 'after sales portal',
                        siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                    },
                },
            },
            {
                name: 'step2',
                tracking: {
                    trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                    trackingTags: {
                        hasOApplication: false,
                        isCustomSiteStructure: true,
                        siteArea: 'after sales',
                        module: '{{persona}}',
                        step: '{{addressStep}}',
                        stepName: 'address information',
                        status: [],
                        type: 'after sales portal',
                        siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                    },
                },
            },
            {
                name: 'step3',
                tracking: {
                    trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                    trackingTags: {
                        hasOApplication: false,
                        isCustomSiteStructure: true,
                        siteArea: 'after sales',
                        module: '{{persona}}',
                        step: '{{curomerDataStep}}',
                        stepName: 'customer data',
                        status: [],
                        type: 'after sales portal',
                        siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                    },
                },
            },
        ],
        confirmationPageTerminationUM: {
            name: 'confirmation-kuendigen-kabel-um',
            route: '/kuendigen/confirmation-kuendigen-kabel-um',
            titleKey: 'CancelContractModule.confirmationPage.title.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination um', 'overview'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination um',
                    step: '{{reviewStep}}',
                    stepName: 'overview',
                    status: ['end', 'success'],
                    type: 'after sales portal',
                    outcome: '{{productOutcome}}',
                },
            },
        },
         confirmationPageTerminationUMDeepLink: {
            name: 'um',
            route: '/kuendigen/um',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            stepper: [
                {
                    name: 'step1',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{step}}',
                            stepName: 'personal information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                        },
                    },
                },
                {
                    name: 'step2',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{addressStep}}',
                            stepName: 'address information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                        },
                    },
                },
                {
                    name: 'step3',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{curomerDataStep}}',
                            stepName: 'customer data',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                        },
                    },
                },
            ],
        },
        confirmationRevocationUM: {
            name: 'confirmation-widerruf-kabel-um',
            route: '/kuendigen/confirmation-widerruf-kabel-um',
            titleKey: 'CancelContractModule.confirmationPage.title.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'revocation um', 'overview'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'revocation um',
                    step: '{{reviewStep}}',
                    stepName: 'overview',
                    status: ['end', 'success'],
                    type: 'after sales portal',
                    outcome: '{{productOutcome}}',
                },
            },
        },
         confirmationRevocationUMDeepLink: {
            name: 'widerruf-um',
            route: '/kuendigen/widerruf-um',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            stepper: [
                {
                    name: 'step1',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{step}}',
                            stepName: 'personal information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                        },
                    },
                },
                {
                    name: 'step2',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{addressStep}}',
                            stepName: 'address information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                        },
                    },
                },
                {
                    name: 'step3',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{curomerDataStep}}',
                            stepName: 'customer data',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                        },
                    },
                },
            ],
        },
        confirmationPageTerminationKD: {
            name: 'confirmation-kuendigen-kabel-vkd',
            route: '/kuendigen/confirmation-kuendigen-kabel-vkd',
            titleKey: 'CancelContractModule.confirmationPage.title.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination kd', 'overview'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination kd',
                    step: '{{reviewStep}}',
                    stepName: 'overview',
                    status: ['end', 'success'],
                    type: 'after sales portal',
                    outcome: '{{productOutcome}}',
                },
            },
        },
        confirmationRevocationKD: {
            name: 'confirmation-widerruf-kabel-vkd',
            route: '/kuendigen/confirmation-widerruf-kabel-vkd',
            titleKey: 'CancelContractModule.confirmationPage.title.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'revocation kd', 'overview'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'revocation kd',
                    step: '{{reviewStep}}',
                    stepName: 'overview',
                    status: ['end', 'success'],
                    type: 'after sales portal',
                    outcome: '{{productOutcome}}',
                },
            },
        },
        confirmationRevocationKDeepLink: {
            name: 'widerruf-vkd',
            route: '/kuendigen/widerruf-vkd',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            stepper: [
                {
                    name: 'step1',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{step}}',
                            stepName: 'personal information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                        },
                    },
                },
                {
                    name: 'step2',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{addressStep}}',
                            stepName: 'address information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                        },
                    },
                },
                {
                    name: 'step3',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{curomerDataStep}}',
                            stepName: 'customer data',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                        },
                    },
                },
            ],
        },
        confirmationPageTerminationKDeepLink: {
            name: 'vkd',
            route: '/kuendigen/vkd',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            stepper: [
                {
                    name: 'step1',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{step}}',
                            stepName: 'personal information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                        },
                    },
                },
                {
                    name: 'step2',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{addressStep}}',
                            stepName: 'address information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                        },
                    },
                },
                {
                    name: 'step3',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{curomerDataStep}}',
                            stepName: 'customer data',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                        },
                    },
                },
            ],
        },
        confirmationRevocationDSL: {
            name: 'confirmation-widerruf-dsl',
            route: '/kuendigen/confirmation-widerruf-dsl',
            titleKey: 'CancelContractModule.confirmationPage.title.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'revocation dsl', 'overview'],
                    siteArea: 'after sales',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'revocation dsl',
                    step: '{{reviewStep}}',
                    stepName: 'overview',
                    status: ['end', 'success'],
                    type: 'after sales portal',
                    outcome: 'tv,internet,other',
                },
            },
        },
        confirmationRevocationDSLDeepLink: {
            name: 'widerruf-dsl',
            route: '/kuendigen/widerruf-dsl',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            stepper: [
                {
                    name: 'step1',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{step}}',
                            stepName: 'personal information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                        },
                    },
                },
                {
                    name: 'step2',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{addressStep}}',
                            stepName: 'address information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                        },
                    },
                },
                {
                    name: 'step3',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{curomerDataStep}}',
                            stepName: 'customer data',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                        },
                    },
                },
            ],
        },
        confirmationTerminationDSL: {
            name: 'confirmation-kuendigen-dsl',
            route: '/kuendigen/confirmation-kuendigen-dsl',
            titleKey: 'CancelContractModule.confirmationPage.title.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination dsl', 'overview'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination dsl',
                    step: '{{reviewStep}}',
                    stepName: 'overview',
                    status: ['end', 'success'],
                    type: 'after sales portal',
                    outcome: '{{productOutcome}}',
                },
            },
        },
        confirmationTerminationDSLDeepLink: {
            name: 'dsl',
            route: '/kuendigen/dsl',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                navigationLink: '/landing-page',
            },
            stepper: [
                {
                    name: 'step1',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{step}}',
                            stepName: 'personal information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'personal information'],
                        },
                    },
                },
                {
                    name: 'step2',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{addressStep}}',
                            stepName: 'address information',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'address information'],
                        },
                    },
                },
                {
                    name: 'step3',
                    tracking: {
                        trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                        trackingTags: {
                            hasOApplication: false,
                            isCustomSiteStructure: true,
                            loginStatus : 'not logged in',
                            siteArea: 'after sales',
                            module: '{{persona}}',
                            step: '{{curomerDataStep}}',
                            stepName: 'customer data',
                            status: [],
                            type: 'after sales portal',
                            siteStructure: ['privatkunden', 'after sales portal', '{{persona}}', 'customer data'],
                        },
                    },
                },
            ],
        },
    },

    termination: {
        name: 'kuendigung',
        route: '/kuendigung',
        salesAgentDsl:{
            name:"dsl-sales-agent-termination",
            route:"/kuendigung/dsl-sales-agent-termination",
            flowManagementID: 'termination-salesagentdsl-without-login',
            titleKey: 'UmCableSalesAgentPage.Moose.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
                navigationLink: '/landing-page',
            },
            tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ["privatkunden", "after sales portal", "termination dsl", "contact us"],
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'termination dsl',
                step: '2',
                stepName: 'contact us',
                status: [],
                type: 'after sales portal',
                context: '{{context}}',
            },
        },
        },
        contractOwnerDeadChooser: {
            name: 'contract-owner-dead-chooser',
            route: '/kuendigung/contract-owner-dead-chooser',
            titleKey: 'terminationModule.contractOwnerDiedChooser.std-headline',
            notifyBeforeUnload: true,
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination {{type}}', 'fatality'],                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination {{type}}',
                    step: '2',
                    stepName: 'fatility',
                    status: [],
                    type: 'after sales portal',
                    context: '{{context}}',
                },
            },
        },
        terminationReasonChooserKD: {
            name: 'kd-gruende',
            route: '/kuendigung/kd-gruende',
            titleKey: 'terminationModule.um-cable-reason-chooser.Fox.titleKey.std-headline',
            flowManagementID: 'um-cable-reason-chooser',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination kd', 'reason to cancel'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination kd',
                    step: '1',
                    stepName: 'reason to cancel',
                    status: ['start'],
                    type: 'after sales portal',
                },
            },
        },
        terminationReasonChooserUM: {
            name: 'um-gruende',
            route: '/kuendigung/um-gruende',
            titleKey: 'terminationModule.um-cable-reason-chooser.Deer.titleKey.std-headline',
            flowManagementID: 'um-cable-reason-chooser',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination um', 'reason to cancel'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination um',
                    step: '1',
                    stepName: 'reason to cancel',
                    status: ['start'],
                    type: 'after sales portal',
                },
            },
        },
        terminationReasonChooserDSL: {
            name: 'dsl-gruende',
            route: '/kuendigung/dsl-gruende',
            titleKey: 'terminationModule.dslReasonChooser.titleKey.std-headline',
            flowManagementID: 'dsl-reason-chooser',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination dsl', 'reason to cancel'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination dsl',
                    step: '1',
                    stepName: 'reason to cancel',
                    status: ["start"],
                    type: 'after sales portal',
                },
            },
        },
        SalesAgentComponent: {
            name: 'sales-agent',
            route: '/kuendigung/sales-agent',
            titleKey: 'salesAgentModule.salesAgentPage.std-headline',
            flowManagementID: 'um-kd-sales-agent',
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
                headerKey: 'common.buttons.back.std-headline',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'termination {{type}}', 'contact us'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination {{type}}',
                    step: '2',
                    stepName: 'contact us',
                    status: [],
                    type: 'after sales portal',
                    context: '{{context}}',
                },
            },
        },
        skipLogin: {
            name: 'skip-login',
            route: '/kuendigung/skip-login',
            titleKey: 'terminationModule.skipLogin.std-headline',
            navigation: {
                topLink: true,
                mobileBtn: false,
                navigationLink: '/landing-page',
                mobileBtnLabelKey: 'common.buttons.back.std-headline',
           },
           tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ['privatkunden', 'after sales portal', 'termination {{type}}', 'cancel contract'],
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'termination {{type}}',
                step: '1',
                stepName: 'cancel contract',
                status: ['start'],
                type: 'after sales portal',
            },
        },
        },
        assistedTermination:{
            name:'assisted-termination',
            route:'/kuendigung/assisted-termination',
            navigation: {
                topLink: false,
                mobileBtn: false,
                navigationLink: '/landing-page',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal','termination {{type}}', 'account agent'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'termination {{type}}',
                    step: '3',
                    stepName: 'account agent',
                    status: [['end','success']],
                    type: 'after sales portal',
                },
            },
        },
    },
    revokationKD: {
    name: 'widerruf',
    route: '/widerruf',
    salesAgentDsl:{
        name:"dsl-sales-agent-revocation",
        route:"/widerruf/dsl-sales-agent-revocation",
        flowManagementID: 'revocation-dslsalesagent-without-login',
        titleKey: 'UmCableSalesAgentPage.Buffalo.std-headline',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
            navigationLink: '/landing-page',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ["privatkunden", "after sales portal", "revocation dsl", "contact us"],
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation dsl',
                step: '2',
                stepName: 'contact us',
                status: [],
                type: 'after sales portal',
                context: '{{context}}',
            },
        },
    },
    umReasonChooser: {
        name: 'um-gruende',
        route: '/widerruf/um-gruende',
        flowManagementID: 'um-cable-reason-chooser',
        titleKey: 'revocationModule.um-cable-reason-chooser.titleKey.std-headline',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.back.std-headline',
            headerKey: 'common.buttons.back.std-headline',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ['privatkunden', 'after sales portal', 'revocation um', 'revoke contract']                    ,
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation um',
                step: '1',
                stepName: 'revoke contract',
                status: ['start'],
                type: 'after sales portal',
            },
        },
    },
    capleReasonChooser: {
        name: 'kd-gruende',
        route: '/widerruf/kd-gruende',
        flowManagementID: 'um-cable-reason-chooser',
        titleKey: 'revocationModule.um-cable-reason-chooser.titleKey.std-headline',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.back.std-headline',
            headerKey: 'common.buttons.back.std-headline',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ['privatkunden', 'after sales portal', 'revocation kd', 'revoke contract']                    ,
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation kd',
                step: '1',
                stepName: 'revoke contract',
                status: ['start'],
                type: 'after sales portal',
            },
        },
    },
    dslReasonChooser: {
        name: 'dsl-gruende',
        route: '/widerruf/dsl-gruende',
        flowManagementID: 'dsl-reason-chooser',
        titleKey: 'revocationModule.dslReasonChooser.titleKey.std-headline',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.back.std-headline',
            headerKey: 'common.buttons.back.std-headline',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ['privatkunden', 'after sales portal', 'revocation dsl', 'revoke contract'],
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation dsl',
                step: '1',
                stepName: 'revoke contract',
                status: ['start'],
                type: 'after sales portal',
            },
        },
    },
    SalesAgentComponent: {
        name: 'sales-agent',
        route: '/widerruf/sales-agent',
        titleKey: 'salesAgentModule.salesAgentPage.std-headline',
        flowManagementID: 'um-kd-sales-agent',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.back.std-headline',
            headerKey: 'common.buttons.back.std-headline',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ['privatkunden', 'after sales portal', 'revocation {{type}}', 'contact us'],
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation {{type}}',
                step: '2',
                stepName: 'contact us',
                status: [],
                type: 'after sales portal',
                context: '{{context}}',
            },
        },
    },
    salesAgentDslHwPurchase:{
        name:"dsl-sales-agent-revocation-purchase-hw",
        route:"/widerruf/dsl-sales-agent-revocation-purchase-hw",
        flowManagementID: 'revocation-dslsalesagent-with-login',
        titleKey: 'UmCableSalesAgentPage.Python.std-headline',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
            headerKey: 'common.buttons.back.std-headline',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ["privatkunden", "after sales portal", "revocation dsl", "contact us"],
                siteArea: 'after sales',
                loginStatus : 'logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation dsl',
                step: '2',
                stepName: 'contact us',
                status: [],
                type: 'after sales portal',
                context: '{{context}}',
            },
        },
    },
    salesAgentDslHwRental:{
        name:"dsl-sales-agent-revocation-rental-hw",
        route:"/widerruf/dsl-sales-agent-revocation-rental-hw",
        flowManagementID: 'revocation-dslsalesagent-with-login',
        titleKey: 'UmCableSalesAgentPage.Cobra.std-headline',
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.back.std-headline',
            headerKey: 'common.buttons.back.std-headline',
        },
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ["privatkunden", "after sales portal", "revocation dsl", "contact us"],
                siteArea: 'after sales',
                loginStatus : 'logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'revocation dsl',
                step: '2',
                stepName: 'contact us',
                status: [],
                type: 'after sales portal',
                context: '{{context}}',
            },
        },
    },
},
    landingPage: {
        name: 'landing-page',
        route: '/landing-page',
        titleKey: 'overview.common.title.std-headline',
        tracking: {
            trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
            trackingTags: {
                hasOApplication: false,
                isCustomSiteStructure: true,
                siteStructure: ['privatkunden', 'after sales portal', 'return portal prestart', 'choose product'],
                siteArea: 'after sales',
                loginStatus : 'not logged in',
                pageType : 'self service',
                platformType : 'responsive',
                module: 'return portal prestart',
                step: '1',
                stepName: 'choose product',
                status: ['start'],
                type: 'after sales portal',
            },
        },
    },
    returnDevices: {
        name: 'geraet-einsenden',
        route: '/geraet-einsenden',
        kabel:{
            name:"kabel",
            route:"/geraet-einsenden/kabel",
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'return hardware', 'start'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'return hardware',
                    step: '1',
                    stepName: 'start',
                    status: ['start'],
                    type: 'after sales portal',
                },
            },
        },
        dsl:{
            name:"dsl",
            route:"/geraet-einsenden/dsl",
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    hasOApplication: false,
                    isCustomSiteStructure: true,
                    siteStructure: ['privatkunden', 'after sales portal', 'return hardware', 'start'],
                    siteArea: 'after sales',
                    loginStatus : 'not logged in',
                    pageType : 'self service',
                    platformType : 'responsive',
                    module: 'return hardware',
                    step: '1',
                    stepName: 'start',
                    status: ['start'],
                    type: 'after sales portal',
                },
            },
        },
        titleKey: 'returnDevicesForm.std-headline',
        notifyBeforeUnload: true,
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: 'common.buttons.backToHomePage.std-headline',
            navigationLink: '/landing-page',
        },
    },
};
